const cards = [
  {
    tag: '娱乐圈',
    title: '某顶流男星深夜密会神秘女子，工作室紧急回应引热议',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20representation%20of%20celebrity%20gossip%20and%20entertainment%20news%2C%20warm%20coral%20and%20peach%20tones%2C%20soft%20geometric%20shapes%2C%20modern%20minimalist%20composition%2C%20editorial%20style%2C%20clean%20background%2C%20no%20text%20no%20people&width=800&height=500&seq=card-01-celeb&orientation=landscape',
    summary: '据知情人士透露，该男星近期频繁出现在某高端小区，引发粉丝猜测。',
    time: '2小时前',
    hot: '98万',
  },
  {
    tag: '网红圈',
    title: '千万粉丝女主播直播带货翻车，被曝虚假宣传遭平台处罚',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20representing%20live%20streaming%20and%20social%20media%20drama%2C%20warm%20orange%20and%20coral%20gradients%2C%20geometric%20patterns%2C%20modern%20minimalist%20style%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-02-livestream&orientation=landscape',
    summary: '平台官方已介入调查，该主播直播间暂时被封禁处理。',
    time: '4小时前',
    hot: '76万',
  },
  {
    tag: '综艺',
    title: '热门综艺录制现场爆发激烈争执，节目组紧急叫停拍摄',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20representing%20TV%20show%20drama%20and%20entertainment%20conflict%2C%20warm%20amber%20and%20soft%20red%20tones%2C%20dynamic%20geometric%20shapes%2C%20editorial%20quality%2C%20clean%20background%2C%20no%20text%20no%20people&width=800&height=500&seq=card-03-variety&orientation=landscape',
    summary: '现场观众爆料称选手与导师之间发生激烈口角，场面一度失控。',
    time: '6小时前',
    hot: '65万',
  },
  {
    tag: '社会热点',
    title: '知名企业家公开言论引全网热议，多个相关话题登上热搜',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20viral%20social%20media%20trending%20topic%2C%20warm%20terracotta%20and%20peach%20gradient%2C%20flowing%20circular%20elements%2C%20modern%20minimalist%2C%20clean%20aesthetic%2C%20no%20text%20no%20people&width=800&height=500&seq=card-04-social&orientation=landscape',
    summary: '各路网友纷纷发表看法，话题阅读量突破5亿次。',
    time: '8小时前',
    hot: '120万',
  },
  {
    tag: '吃瓜大赛',
    title: '第51届吃瓜大赛总决赛精彩回顾：神级操作引爆全场',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20colorful%20digital%20art%20representing%20competition%20and%20excitement%2C%20warm%20orange%20red%20and%20gold%20tones%2C%20dynamic%20flowing%20shapes%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-05-contest&orientation=landscape',
    summary: '冠军选手以碾压式表现夺得桂冠，精彩回放视频已上架。',
    time: '12小时前',
    hot: '54万',
  },
  {
    tag: '娱乐圈',
    title: '多部热门剧集同期开播，收视率大战一触即发引网友押注',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20representing%20TV%20drama%20and%20entertainment%20showdown%2C%20warm%20coral%20and%20soft%20gold%20gradients%2C%20layered%20geometric%20forms%2C%20modern%20minimalist%2C%20clean%20background%2C%20no%20text%20no%20people&width=800&height=500&seq=card-06-drama&orientation=landscape',
    summary: '各大平台纷纷放出预告片造势，网友开启花式投票模式。',
    time: '1天前',
    hot: '88万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🔥 热门吃瓜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网最新最热的吃瓜资讯，一网打尽不遗漏
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/50 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-0.5 bg-black/50 text-white text-xs rounded-full whitespace-nowrap">
                  <i className="ri-fire-line text-[10px]"></i>
                  {card.hot}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {card.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}